"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeleteGalleryImage = exports.DELETE_GALLERY_IMAGE_PROJECT_ACTION_TYPE = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
exports.DELETE_GALLERY_IMAGE_PROJECT_ACTION_TYPE = 'DELETE_GALLERY_IMAGE';
const deleteGalleryImageRuleSet = {
  type: value => value === exports.DELETE_GALLERY_IMAGE_PROJECT_ACTION_TYPE,
  galleryImageId: typeguard_1.isNonEmptyString,
  galleryId: typeguard_1.isNonEmptyString
};
const isDeleteGalleryImage = p => (0, ProjectAction_1.isBaseProjectAction)(p) && (0, typeguard_1.isType)(p, deleteGalleryImageRuleSet);
exports.isDeleteGalleryImage = isDeleteGalleryImage;